import { Container, Stack, Typography, Paper } from '@mui/material';

const Section = ({ title, children }) => (
  <Stack spacing={1}>
    <Typography variant="h6" fontWeight={800} color="text.primary">
      {title}
    </Typography>
    {children}
  </Stack>
);

const TermsPage = () => (
  <Container maxWidth="md" sx={{ py: { xs: 3, md: 5 } }}>
    <Paper variant="outlined" sx={{ p: { xs: 2.5, md: 4 } }}>
      <Stack spacing={2.5}>
        <Stack spacing={0.5}>
          <Typography variant="h4" fontWeight={900} color="text.primary">
            Terms of Service
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Last Updated: December 20, 2025
          </Typography>
          <Typography color="text.secondary">
            Welcome to QuoteSlicer.com (“we,” “us,” “our”). By accessing or using this website, you agree to these Terms of Service. If you do not
            agree, do not use the site.
          </Typography>
        </Stack>

        <Section title="1. No Insurance, Legal, or Financial Advice">
          <Typography>
            SmartlyRich.com is not an insurance company, broker, agent, financial institution, or legal advisor. We do not sell policies or
            provide professional advice. All content is for informational and marketing purposes only.
          </Typography>
        </Section>

        <Section title="2. How Our Service Works">
          <Typography>
            SmartlyRich.com operates as an advertising-supported referral platform. We connect users with third-party companies such as insurance
            carriers, brokers, and service providers. When you click links, submit information, or call phone numbers listed on our site, we may
            receive compensation.
          </Typography>
          <Typography>Compensation may influence:</Typography>
          <ul style={{ paddingLeft: '1.1rem', margin: 0 }}>
            <li>The order in which partners appear.</li>
            <li>The companies we feature.</li>
            <li>The offers displayed.</li>
          </ul>
          <Typography>We do not represent all providers in the market.</Typography>
        </Section>

        <Section title="3. Third-Party Partners">
          <Typography>
            When you interact with a partner (e.g., request a quote), you are dealing directly with them, not us. We cannot control their prices,
            decisions, underwriting, data handling practices, or contract terms. Your interactions with them are governed by their terms and
            privacy policies.
          </Typography>
        </Section>

        <Section title="4. No Guarantees">
          <Typography>We do not guarantee:</Typography>
          <ul style={{ paddingLeft: '1.1rem', margin: 0 }}>
            <li>Quote accuracy.</li>
            <li>Eligibility or approval.</li>
            <li>Pricing or savings.</li>
          </ul>
        </Section>

        <Section title="5. User Responsibilities">
          <Typography>
            You must provide accurate information and use this site for lawful purposes. You agree not to misuse the site or attempt to interfere
            with its operation.
          </Typography>
        </Section>

        <Section title="6. Intellectual Property">
          <Typography>
            All content, logos, and trademarks on this site are owned by us or our partners. You may not copy, distribute, or use them without
            permission.
          </Typography>
        </Section>

        <Section title="7. Limitation of Liability">
          <Typography>
            We are not liable for any direct, indirect, incidental, or consequential damages arising from your use of the site or services
            obtained through partners.
          </Typography>
        </Section>

        <Section title="8. Changes to These Terms">
          <Typography>We may update these Terms at any time. Continued use of the site means you accept the updated Terms.</Typography>
        </Section>

        <Section title="9. Contact Us">
          <Typography>Email: supply@upads.com</Typography>
          <Typography>Address: 4 W Palisade Ave #1267, Englewood, NJ 07631, United States</Typography>
        </Section>
      </Stack>
    </Paper>
  </Container>
);

export default TermsPage;
